import React from 'react';

export default function IPRestrictionMessage() {

    return (
        <div className="main-content">
            <div className="alert-warning">
                <img
                    src="/assets/image/icon-warning-pknowledge.svg"
                    alt="aa"
                    className="shrink-img"
                />
            </div>
            <div className="title-notify">このIPアドレスは許可されていません。</div>
            <div className="title-notify">IP restrictions are enabled.</div>
            <div className="text-notify-detail">
                IP制限が有効にされています。SolutionDesk管理者へお問い合わせください。
            </div>
            <div className="text-notify-detail">
                IP restrictions are currently enabled. Please contact the SolutionDesk administrator.
            </div>
        </div>
    );
}